import { Component } from 'react';
import passed from '../../../assets/img/performances/PASSED_GREEN@2x.png';

class PerformanceBar extends Component {
  hasReachedTarget() {
    const { incentive } = this.props;
    return incentive.packs_sold >= incentive.target;
  }

  hasReachedBaseTarget() {
    const { incentive } = this.props;
    return incentive.packs_sold >= incentive.base_target;
  }

  performanceBarBGColor() {
    if (this.hasReachedTarget()) {
      return '#70bd4d';
    }
    return '#ffc734';
  }

  performanceBaseTargetBarBGColor() {
    if (this.hasReachedBaseTarget()) {
      return '#70bd4d';
    }
    return '#ffc734';
  }

  incentiveIsBaseTarget = () => {
    const { incentive } = this.props;
    return incentive.kind === 'base_target';
  }

  render() {
    const { incentive } = this.props;
    const progress = Math.min(Math.floor((incentive.packs_sold / incentive.target) * 100), 100);
    const baseTargetProgress = this.incentiveIsBaseTarget() ?
      Math.min(Math.floor((incentive.base_target / incentive.target) * 100), 100) : 0;

    return (
      <div className="performance-bar-wrapper">
        {!this.hasReachedTarget() && (
          <div className="sold-indicator" style={ { left: `calc(${progress}% - ${`${incentive.packs_sold}`.length / 2.0}em)` } }>
            <strong>{incentive.packs_sold}</strong>
            <br />
            <span className="glyphicon glyphicon-triangle-bottom" aria-hidden="true"></span>
          </div>
        )}
        <div className="performance-bar-back"></div>
        <div className="performance-bar" style={ { backgroundColor: this.performanceBarBGColor() } }></div>
        {this.incentiveIsBaseTarget() && (
          <div
            className="performance-bar"
            style={ {
              left: 0,
              width: `${baseTargetProgress}%`,
              zIndex: 10,
              backgroundColor: this.performanceBaseTargetBarBGColor()
            } }
          >
          </div>
        )}
        <div className="performance-bar-overlay" style={ { width: `${100 - progress}%` } }></div>
        <div className="target-indicator">
          <div className="target-divider">
            <span className="target-divider-left"></span>
            <span className="target-divider-right"></span>
          </div>
          <div className="target-label">TARGET</div>
          <div className="target-value"><strong>{incentive.target}</strong></div>
        </div>
        {this.incentiveIsBaseTarget() && (
          <div className="target-indicator" style={ { left: `calc(${baseTargetProgress}% - 2.7em)` } }>
            <div className="target-divider">
              <span className="target-divider-left"></span>
              <span className="target-divider-right"></span>
            </div>
            <div className="target-label">TARGET</div>
            <div className="target-value">
              <strong style={ { color: this.performanceBaseTargetBarBGColor() } }>{incentive.base_target}</strong>
            </div>
          </div>
        )}
        {this.hasReachedTarget() && (
          <div className="green-tick">
            <div className="green-tick-text">
              <strong>{incentive.packs_sold}</strong>
            </div>
            <div className="green-tick-image">
              <img src={passed} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default PerformanceBar;
